/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebhookDeliveryTrigger } from './WebhookDeliveryTrigger';
import {
    WebhookDeliveryTriggerFromJSON,
    WebhookDeliveryTriggerFromJSONTyped,
    WebhookDeliveryTriggerToJSON,
    WebhookDeliveryTriggerToJSONTyped,
} from './WebhookDeliveryTrigger';
import type { WebhookDeliveryState } from './WebhookDeliveryState';
import {
    WebhookDeliveryStateFromJSON,
    WebhookDeliveryStateFromJSONTyped,
    WebhookDeliveryStateToJSON,
    WebhookDeliveryStateToJSONTyped,
} from './WebhookDeliveryState';
import type { CompanyWebhookEventType } from './CompanyWebhookEventType';
import {
    CompanyWebhookEventTypeFromJSON,
    CompanyWebhookEventTypeFromJSONTyped,
    CompanyWebhookEventTypeToJSON,
    CompanyWebhookEventTypeToJSONTyped,
} from './CompanyWebhookEventType';

/**
 * One delivery of an event to a webhook: a system send or a manual redelivery. The automatic HTTP attempts inside it are summarised by attemptCount and the last status. The bodies are on WebhookDeliveryDetail.
 * @export
 * @interface WebhookDelivery
 */
export interface WebhookDelivery {
    /**
     * 
     * @type {string}
     * @memberof WebhookDelivery
     */
    companyWebhookDeliveryId: string;
    /**
     * Absent once the webhook it was sent to has been deleted.
     * @type {string}
     * @memberof WebhookDelivery
     */
    companyWebhookId?: string;
    /**
     * Absent for draft_created, which has no shipment yet.
     * @type {string}
     * @memberof WebhookDelivery
     */
    shipmentId?: string;
    /**
     * The same for every delivery of one event, so a redelivery can be deduplicated.
     * @type {string}
     * @memberof WebhookDelivery
     */
    eventId: string;
    /**
     * 
     * @type {CompanyWebhookEventType}
     * @memberof WebhookDelivery
     */
    eventType: CompanyWebhookEventType;
    /**
     * The URL at send time, which may differ from the webhook's current URL.
     * @type {string}
     * @memberof WebhookDelivery
     */
    webhookUrl: string;
    /**
     * 
     * @type {WebhookDeliveryState}
     * @memberof WebhookDelivery
     */
    state: WebhookDeliveryState;
    /**
     * 
     * @type {number}
     * @memberof WebhookDelivery
     */
    attemptCount: number;
    /**
     * Last HTTP status received. Absent when no response arrived (timeout, DNS failure).
     * @type {number}
     * @memberof WebhookDelivery
     */
    httpStatus?: number;
    /**
     * Why the delivery failed when there is no HTTP status to say so.
     * @type {string}
     * @memberof WebhookDelivery
     */
    errorMessage?: string;
    /**
     * 
     * @type {WebhookDeliveryTrigger}
     * @memberof WebhookDelivery
     */
    trigger: WebhookDeliveryTrigger;
    /**
     * Who asked for a manual redelivery. Absent on system deliveries.
     * @type {string}
     * @memberof WebhookDelivery
     */
    triggeredByEmail?: string;
    /**
     * The original delivery this one re-sent. Absent on system deliveries.
     * @type {string}
     * @memberof WebhookDelivery
     */
    retriedFromDeliveryId?: string;
    /**
     * How many times the customer has already re-sent this delivery (or the delivery it re-sends). Compare with maxCustomerRetries on the list response.
     * @type {number}
     * @memberof WebhookDelivery
     */
    customerRetryCount: number;
    /**
     * Whether some send of this event (the original or a redelivery of it) reached the endpoint. Once one has, the event can no longer be re-sent from here.
     * @type {boolean}
     * @memberof WebhookDelivery
     */
    eventDelivered: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WebhookDelivery
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebhookDelivery
     */
    deliveredAt?: Date;
    /**
     * When the retry queue will try a pending delivery again.
     * @type {Date}
     * @memberof WebhookDelivery
     */
    nextAttemptAt?: Date;
}



/**
 * Check if a given object implements the WebhookDelivery interface.
 */
export function instanceOfWebhookDelivery(value: object): value is WebhookDelivery {
    if (!('companyWebhookDeliveryId' in value) || value['companyWebhookDeliveryId'] === undefined) return false;
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('webhookUrl' in value) || value['webhookUrl'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('attemptCount' in value) || value['attemptCount'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('customerRetryCount' in value) || value['customerRetryCount'] === undefined) return false;
    if (!('eventDelivered' in value) || value['eventDelivered'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function WebhookDeliveryFromJSON(json: any): WebhookDelivery {
    return WebhookDeliveryFromJSONTyped(json, false);
}

export function WebhookDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookDelivery {
    if (json == null) {
        return json;
    }
    return {
        
        'companyWebhookDeliveryId': json['companyWebhookDeliveryId'],
        'companyWebhookId': json['companyWebhookId'] == null ? undefined : json['companyWebhookId'],
        'shipmentId': json['shipmentId'] == null ? undefined : json['shipmentId'],
        'eventId': json['eventId'],
        'eventType': CompanyWebhookEventTypeFromJSON(json['eventType']),
        'webhookUrl': json['webhookUrl'],
        'state': WebhookDeliveryStateFromJSON(json['state']),
        'attemptCount': json['attemptCount'],
        'httpStatus': json['httpStatus'] == null ? undefined : json['httpStatus'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'trigger': WebhookDeliveryTriggerFromJSON(json['trigger']),
        'triggeredByEmail': json['triggeredByEmail'] == null ? undefined : json['triggeredByEmail'],
        'retriedFromDeliveryId': json['retriedFromDeliveryId'] == null ? undefined : json['retriedFromDeliveryId'],
        'customerRetryCount': json['customerRetryCount'],
        'eventDelivered': json['eventDelivered'],
        'createdAt': (new Date(json['createdAt'])),
        'deliveredAt': json['deliveredAt'] == null ? undefined : (new Date(json['deliveredAt'])),
        'nextAttemptAt': json['nextAttemptAt'] == null ? undefined : (new Date(json['nextAttemptAt'])),
    };
}

  export function WebhookDeliveryToJSON(json: any): WebhookDelivery {
      return WebhookDeliveryToJSONTyped(json, false);
  }

  export function WebhookDeliveryToJSONTyped(value?: WebhookDelivery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyWebhookDeliveryId': value['companyWebhookDeliveryId'],
        'companyWebhookId': value['companyWebhookId'],
        'shipmentId': value['shipmentId'],
        'eventId': value['eventId'],
        'eventType': CompanyWebhookEventTypeToJSON(value['eventType']),
        'webhookUrl': value['webhookUrl'],
        'state': WebhookDeliveryStateToJSON(value['state']),
        'attemptCount': value['attemptCount'],
        'httpStatus': value['httpStatus'],
        'errorMessage': value['errorMessage'],
        'trigger': WebhookDeliveryTriggerToJSON(value['trigger']),
        'triggeredByEmail': value['triggeredByEmail'],
        'retriedFromDeliveryId': value['retriedFromDeliveryId'],
        'customerRetryCount': value['customerRetryCount'],
        'eventDelivered': value['eventDelivered'],
        'createdAt': ((value['createdAt']).toISOString()),
        'deliveredAt': value['deliveredAt'] == null ? undefined : ((value['deliveredAt']).toISOString()),
        'nextAttemptAt': value['nextAttemptAt'] == null ? undefined : ((value['nextAttemptAt']).toISOString()),
    };
}

